const colors = {
  line: "#DEDEDE",
  black: "#1A1A1A",
  border: "#8E8E8E",
  maroon: "#692925",
  primaryGray: "#6B6B6B",
  secondaryGray: "#B3B3B3",
  textMuted: "#CBCBCB",
  blackMuted: "#000000c6;",
  white: "#FFFFFF",
};
export default colors;
